import * as z from 'zod';

import OutcomeSchema from './OutcomeSchema';
import StageSchema from './StageSchema';

export const LastMatchSchema = z.object({
  homeTeam: z.string(),
  awayTeam: z.string(),
  homeScore: z.number(),
  awayScore: z.number(),
  homePenaltyScore: z.number().nullable(),
  awayPenaltyScore: z.number().nullable(),
  outcome: OutcomeSchema,
  homeGoalscorers: z.array(z.string()),
  awayGoalscorers: z.array(z.string()),
  date: z.string(),
  league: z.string(),
  leagueFlag: z.string().nullable(),
  stage: StageSchema.nullable(),
  stageNumber: z.number().nullable(),
});

const LastFiveGamesSchema = z.object({
  homeLastMatches: z.array(LastMatchSchema),
  awayLastMatches: z.array(LastMatchSchema),
});

export default LastFiveGamesSchema;
